import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./../../styleSheet/main/admin/addAnnouncements/addAnnouncements.css";
import { useAuth, FLASK_URL } from "../../AuthContext";
import orangeSortIcon from "./../../media/orange-sort-icon.svg";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import carIcon from "./../../media/announcements/car.svg";
import computerIcon from "./../../media/announcements/computer.svg";
import documentsIcon from "./../../media/announcements/documents.svg";
import exclamationIcon from "./../../media/announcements/exclamation.svg";
import familyIcon from "./../../media/announcements/family.svg";
import planeIcon from "./../../media/announcements/plane.svg";
import foodIcon from "./../../media/announcements/food.svg";
import plantIcon from "./../../media/announcements/plant.svg";
import questionIcon from "./../../media/announcements/question.svg";
import starIcon from "./../../media/announcements/star.svg";
import toolsIcon from "./../../media/announcements/tools.svg";
import peopleIcon from "./../../media/announcements/people.svg";
import Logger from "../../utils/Logger";
import { useNotification } from "../../components/NotificationContext";
import httpClient from "../../services/httpClient";
import RichTextEditor from "../../components/richTextEditor/richTextEditor";

function AddAnnouncement() {
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  const [isIconListOpen, setIsIconListOpen] = useState(false);
  // const { showNotification } = useNotification();

  const { keycloak } = useAuth();
  const accessToken = keycloak?.token;

  const handleIconSelect = (iconKey) => {
    setSelectedIcon(iconKey);
    setIsIconListOpen(false); // Zamknięcie listy po wyborze ikony
  };

  const ICONS = {
    car: carIcon,
    computer: computerIcon,
    documents: documentsIcon,
    exclamation: exclamationIcon,
    family: familyIcon,
    plane: planeIcon,
    food: foodIcon,
    plant: plantIcon,
    question: questionIcon,
    star: starIcon,
    tools: toolsIcon,
    people: peopleIcon,
  };

  const [selectedIcon, setSelectedIcon] = useState("exclamation"); // Domyślna ikona

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Walidacja
    if (!title || !details) {
      // showNotification("Wszystkie pola są wymagane!", "error");
      return;
    }

    const announcementData = {
      title: title,
      details: details,
      icon: selectedIcon,
    };

    try {
      const response = await httpClient.post(
        "/announcements",
        announcementData,
        {
          withAuth: true,
        },
      );

      const result = response.data;
      Logger.log("Odpowiedź serwera:", result);

      // Wyczyszczenie formularza i ustawienie komunikatu o sukcesie
      setTitle("");
      setDetails("");
      setSuccessMessage("Ogłoszenie zostało dodane pomyślnie!");
      // showNotification("Ogłoszenie zostało dodane pomyślnie!", "success");

      setTimeout(() => {
        navigate("/administrator/aktualnosci");
      }, 500);
    } catch (error) {
      Logger.error("Błąd:", error);
      // showNotification(
      //   "Nie udało się dodać ogłoszenia. Zaloguj się jeszcze raz.",
      //   "error"
      // );
    }
  };

  return (
    <div className="add-announcement-container">
      <div className="main-site">
        <h1>{t("announcementEditor.addTitle")}</h1>
        <div
          className="orange-sort-icon"
          onClick={() => navigate("/administrator/aktualnosci")}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            backgroundImage: `url(${orangeSortIcon})`,
            transform: hover ? "rotate(180deg)" : "rotate(90deg)",
            cursor: "pointer",
          }}
        />
      </div>
      <form onSubmit={handleSubmit} className="add-announcement-form">
        <div className="form-layout">
          {/* LEWA STRONA - WYBÓR IKONY */}
          <div className="icon-section">
            <label htmlFor="icon">{t("announcementEditor.selectIcon")}</label>
            <div className="icon-selector">
              <img
                src={ICONS[selectedIcon]}
                alt="Wybrana ikona"
                className="selected-icon"
                onClick={() => setIsIconListOpen(!isIconListOpen)}
              />
              {isIconListOpen && (
                <div className="icon-list">
                  {Object.keys(ICONS).map((iconKey) => (
                    <div key={iconKey} className="icon-item-wrapper">
                      <img
                        src={ICONS[iconKey]}
                        alt={iconKey}
                        className="icon-item"
                        onClick={() => handleIconSelect(iconKey)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* PRAWA STRONA - TYTUŁ I SZCZEGÓŁY */}
          <div className="details-section">
            <div className="form-group">
              <label htmlFor="title">
                {t("announcementEditor.announcementTitle")}
              </label>
              <input
                type="text"
                id="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder={t("announcementEditor.enterTitle")}
              />
            </div>
            <div className="form-group">
              <label htmlFor="details">
                {t("announcementEditor.announcementDetails")}
              </label>
              <RichTextEditor content={details} onChange={setDetails} />
            </div>
          </div>
        </div>

        <button type="submit" className="submit-button">
          {t("announcementEditor.addButton")}
        </button>
      </form>

      {successMessage && (
        <div className="success-message">{successMessage}</div>
      )}
    </div>
  );
}

export default AddAnnouncement;
